import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Switch } from '@teo/components';
import { Theme } from '@teo/components/icons';
import { findUniqueSourcesAndTargets } from '@/components/LearningPath/util';

const ActionLP = ({
  nodeSelected,
  edges,
  nodes,
  setNodes,
  handleMakeTheme,
}) => {
  const { t } = useTranslation();
  const [selectChild, setSelectChild] = useState(false);
  const [themeDisabled, setThemeDisabled] = useState(false);

  useEffect(() => {
    const rawSelected = nodes.filter((n) => n.selected);
    const isDisable = rawSelected?.find(
      (nds) =>
        nds?.data?.courseType == 'milestone' ||
        nds?.data?.courseType == 'learningpath'
    );
    if (isDisable) {
      setThemeDisabled(true);
    } else {
      setThemeDisabled(false);
    }
  }, [nodes]);

  const handkeSelectChild = (isCheck) => {
    setSelectChild(isCheck);
    const uniqueValues = findUniqueSourcesAndTargets(nodeSelected?.id, edges);
    setNodes((nds) =>
      nds?.map((el) => {
        if (uniqueValues.includes(el.id)) {
          return { ...el, selected: true };
        }
        return el;
      })
    );
  };

  return (
    <div className="border-t p-5">
      <h4 className="mb-3 text-base">
        {t('pages.learning_path.actions_label')}
      </h4>
      <Button
        variant="ghost"
        className="flex items-center gap-2"
        onClick={() => handleMakeTheme(nodeSelected)}
        disabled={themeDisabled}
      >
        <Theme className="w-5" />
        {t('pages.learning_path.make_theme')}
      </Button>
      <div className="mt-5 flex flex-row items-center gap-4 rounded-lg border border-grey-02 p-4">
        <div>
          <Switch
            checked={selectChild}
            onChange={(isCheck) => handkeSelectChild(isCheck)}
            setSelectChild
          />
        </div>
        <div>
          <h4 className="font-normal">
            {t('pages.learning_path.all_children')}
          </h4>
        </div>
      </div>
    </div>
  );
};
export default ActionLP;
